var map = {
	"./0B.png": 8031,
	"./0G.png": 1444,
	"./0R.png": 4268,
	"./0Y.png": 1297,
	"./1B.png": 4129,
	"./1G.png": 6221,
	"./1R.png": 8185,
	"./1Y.png": 8874,
	"./2B.png": 5595,
	"./2G.png": 4810,
	"./2R.png": 554,
	"./2Y.png": 5263,
	"./3B.png": 3483,
	"./3G.png": 3235,
	"./3R.png": 4026,
	"./3Y.png": 263,
	"./4B.png": 5670,
	"./4G.png": 1510,
	"./4R.png": 5970,
	"./4Y.png": 5604,
	"./5B.png": 6441,
	"./5G.png": 1668,
	"./5R.png": 7333,
	"./5Y.png": 4572,
	"./6B.png": 3669,
	"./6G.png": 1587,
	"./6R.png": 8432,
	"./6Y.png": 3278,
	"./7B.png": 8345,
	"./7G.png": 233,
	"./7R.png": 753,
	"./7Y.png": 1497,
	"./8B.png": 5314,
	"./8G.png": 85,
	"./8R.png": 1694,
	"./8Y.png": 2471,
	"./9B.png": 1114,
	"./9G.png": 33,
	"./9R.png": 8071,
	"./9Y.png": 3007,
	"./D2B.png": 3493,
	"./D2G.png": 258,
	"./D2R.png": 5790,
	"./D2Y.png": 5504,
	"./D4W.png": 2033,
	"./TB.png": 1596,
	"./TG.png": 9977,
	"./TR.png": 1922,
	"./TY.png": 395,
	"./W.png": 8439,
	"./skipB.png": 6434,
	"./skipG.png": 3750,
	"./skipR.png": 5626,
	"./skipY.png": 4899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9327;